var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { TextDisplay } from '@i18nspect/types';
import state from '../state';
import useSubscribe from '../../../hooks/useSubscribe';
import bridge from '../../../bridge';
import { onLanguageInspect } from '../utils';
import { filterReactElementParams, restoreTextReactElements, } from '../../../utils/components';
export var TextWrapper = function (_a) {
    var key = _a.textKey, originalValue = _a.originalValue, params = _a.params, isMobile = _a.isMobile, finalNamespace = _a.finalNamespace;
    var i18n = state.getInterceptorI18n();
    useSubscribe();
    var ref = useRef(null);
    var tFunctionParamsOverride = {
        ns: finalNamespace,
        lng: undefined,
        lngs: undefined,
        fallbackLng: undefined,
        postProcess: undefined,
    };
    var content = (function () {
        var slicedKey = key.length > 30 ? "".concat(key.slice(0, 30), "...") : key;
        if (state.display === TextDisplay.Key) {
            return slicedKey;
        }
        var _a = filterReactElementParams({
            params: params,
            elementTypes: ['TextWrapper', 'DateWrapper'],
        }), filteredParams = _a.filteredParams, reactElementParams = _a.reactElementParams;
        var hasReactElements = Object.keys(reactElementParams).length !== 0;
        var text = i18n.t(key, __assign(__assign({}, filteredParams), tFunctionParamsOverride));
        return hasReactElements
            ? restoreTextReactElements({
                text: text,
                reactElementParams: reactElementParams,
            })
            : text;
    })();
    var isKeyExist = i18n.exists(key, __assign(__assign({}, params), tFunctionParamsOverride));
    var redHighlight = state.display === TextDisplay.Language && !isKeyExist;
    var onClickFont = function (e) {
        if (!isMobile)
            return;
        if (state.enableInspect) {
            e.stopPropagation();
            onLanguageInspect(e, { key: key, namespace: finalNamespace });
        }
    };
    var onMouseEnter = function () {
        var _a;
        if (!ref.current)
            return;
        var _b = (_a = ref.current.getBoundingClientRect()) !== null && _a !== void 0 ? _a : {
            top: 0,
            left: 0,
        }, top = _b.top, left = _b.left;
        bridge.language.hover({
            key: key,
            namespace: finalNamespace,
            projectAndNamespace: finalNamespace,
            defaultValue: params.defaultValue,
            position: { x: left, y: top },
        });
    };
    return (_jsx("font", __assign({ ref: function (el) {
            ref.current = el;
            if (el) {
                if (redHighlight) {
                    el.style.setProperty('outline', '2px dashed red', 'important');
                }
                else {
                    el.style.setProperty('outline', '1px dashed green', 'important');
                }
            }
        }, onMouseEnter: onMouseEnter, onClick: onClickFont }, { children: content })));
};
